var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide"},[_c('Tooltip',{attrs:{"content":"新手引导","placement":"bottom"}},[_c('Button',{attrs:{"type":"text"}},[_c('Icon',{attrs:{"type":"ios-help-circle-outline","size":23},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.guide($event)}}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92482df2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/components/guide/index.vue
// module id = cnS/
// module chunks = 64